import React from "react";
import '../../App.css';

export default function Destinations() {
  return <h1 className="destinations">DESTINATIONS</h1>
}